import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  Col,
  Row,
  Space,
  Table,
  Tooltip,
  Typography,
  message,
} from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useColumnTable } from "./table/data.table.inactive";
import requets from "../../api";
import { useTranslation } from "react-i18next";
import { ReportCsv } from "../../api/service/report/reportCsv";
import { ReportExcel } from "../../api/service/report/reportExcel";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { useAppAuth } from "../../context/use-app-auth";

const { Title } = Typography;

export default function DeviceInactive() {
  const auth = useAppAuth();
  const req = useMemo(() => requets(auth.user?.access_token), [auth.user?.access_token]);
  const { t } = useTranslation("global");
  const [messageSend, contextHolder] = message.useMessage();
  const controlPanel = useSelector((state) => state.controlPanel);
  const [data, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = useColumnTable();

  const getDevices = useCallback(
    (control) => {
      const { department, county, zone, devEui } = control;
      setLoading(true);
      req
        .get("/device/filter/", { department, county, zone, devEui })
        .then((response) => {
          const raw = response.data;
          const all = Array.isArray(raw) ? raw : (raw?.data || []);
          setDataSource(all.filter((d) => d.isActive === false));
        })
        .catch(() => setDataSource([]))
        .finally(() => setLoading(false));
    },
    [req],
  );

  useEffect(() => {
    getDevices(controlPanel);
  }, [controlPanel]);

  const translate = useCallback(
    (rows) =>
      rows.map((item) => {
        const raw = {
          nameDevice: item.name,
          description: item.description,
          eui: item.devEui,
          join: item.joinEui,
          appkey: item.appKey,
          zone: item.zone?.label ?? "-",
          marquille: item.marquille,
          brand: item.brand,
          state:
            item.state === 0
              ? t("reports.tableColumn.stateValueOff")
              : t("reports.tableColumn.stateValueOn"),
          status:
            item.status === "Fail"
              ? t("reports.tableColumn.statusValueBad")
              : t("reports.tableColumn.statusValueGood"),
          consecutive: item.consecutive,
          manufacturingDate: item.manufacturingDate,
          installationDate: item.installationDate,
        };
        const out = {};
        for (const key in raw) {
          out[t(`device.tableColumn.${key}`)] = raw[key];
        }
        return out;
      }),
    [t],
  );

  const exportFileName = `${t("device.devicesReport")}-${dayjs().format("YYYY-MM-DD")}`;

  return (
    <div className="layout-content">
      {contextHolder}
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col xs={24} className="mb-24">
          <Card
            bordered={false}
            className="header-solid h-full ant-card-p-0"
            title={
              <Title level={4} style={{ margin: 0 }}>
                {t("device.titleInactive")}
              </Title>
            }
            extra={
              <Tooltip title={t("device.reload")}>
                <Button
                  type="text"
                  icon={<ReloadOutlined />}
                  onClick={() => getDevices(controlPanel)}
                />
              </Tooltip>
            }
          >
            <Row justify="end" style={{ marginBottom: 16 }}>
              <Col>
                <Space wrap>
                  <ReportExcel dataSet={translate(data)} fileName={exportFileName} />
                  <ReportCsv dataSet={translate(data)} fileName={exportFileName} />
                </Space>
              </Col>
            </Row>
            <div style={{ padding: "0 24px 24px" }}>
              <Table
                columns={columns}
                dataSource={data}
                rowKey="devEui"
                loading={loading}
                scroll={{ x: "max-content" }}
                pagination={{
                  pageSize: 10,
                  showSizeChanger: true,
                  showTotal: (total) => `${t("device.total")}: ${total}`,
                }}
              />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
